<template>
  <div>
    <div class="pool_hd">
      <ul>
        <li>
          <span>项目总数</span>
          <em>{{ poolProList.total }}</em>
        </li>
        <li>
          <span>合作中</span>
          <em>{{ poolProList.cooperate }}</em>
        </li>
        <li>
          <span>正常</span>
          <em>{{ poolProList.normal }}</em>
        </li>
        <li>
          <span style="color: #d9001b">快没钱</span>
          <em>{{ poolProList.soon }}</em>
        </li>
        <li>
          <span>不合作</span>
          <em>{{ poolProList.close }}</em>
        </li>
      </ul>
    </div>
    <div class="pool_bd">
      <div class="pool_bd_title">
        <div class="pool_bd_content">
          <div class="pool_tab">
            <div v-for="(item, i) in poolList" :key="i" class="pool_tab_box">
              <div
                @click="getPoolList(item.id, i)"
                :class="{ active: tabNum == i }"
              >
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
          <el-input
            placeholder="请输入搜索关键字"
            class="input-with-select"
            v-model="searchValue.keyword"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchPoolList"
            ></el-button>
          </el-input>
        </div>
        <div>
          <el-button type="primary" icon="el-icon-plus" @click="addPro"
            >创建项目</el-button
          >
        </div>
      </div>
      <el-table
        stripe
        ref="table"
        v-loading="loadingData"
        :data="tableData"
        :max-height="tableHeight"
        border
        style="width: 100%"
      >
        <el-table-column prop="project_id" label="项目ID" fixed>
        </el-table-column>
        <el-table-column prop="project_name" label="项目名称">
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status == 0" size="mini" type="danger"
              >下架</el-button
            >
            <el-button v-if="scope.row.status == 1" size="mini" type="success"
              >正常</el-button
            >
            <el-button v-if="scope.row.status == 2" size="mini" type="warning"
              >快没钱</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="" label="库存">
          <template slot-scope="scope">
            <span>{{ scope.row.surplus_prepaid_amount }}</span
            >/
            <span>{{ scope.row.valve_amount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="divide" label="当前分成比例">
          <template slot-scope="scope">
            <span>{{ scope.row.divide }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="method.name" label="结算类型"> </el-table-column>
        <el-table-column label="操作" width="340px">
          <template slot-scope="scope">
            <el-button
              type="primary"
              plain
              @click="poolDetails(scope.row, scope.row.project_id)"
              >详情</el-button
            >
            <el-button
              type="primary"
              plain
              @click="poolEditDialog(scope.row, scope.row.project_id)"
              >编辑</el-button
            >
            <el-button
              type="primary"
              plain
              @click="poolAddDialog(scope.row.project_id)"
              >添加</el-button
            >

            <el-button
              type="danger"
              plain
              v-if="scope.row.status > 0"
              @click="closeProejct(scope.row.project_id)"
              >下架</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalRecords"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 预付池 新增弹窗 -->
    <el-dialog
      title="新增项目"
      :visible.sync="addDialogFormVisible"
      :close-on-click-modal="false"
      style="margin-top: 5vh"
      width="38%"
    >
      <div>
        <el-form ref="form" :model="addform" label-width="90px">
          <div class="form-part">
            <el-form-item label="项目名称:">
              <el-input placeholder="" v-model="addform.project_name">
              </el-input>
            </el-form-item>
            <span
              class="msg-style"
              v-if="
                msgKey.project_name != undefined || msgKey.project_name != null
              "
              >{{ msgError.project_name[0] }}</span
            >
          </div>
          <div class="form-part">
            <el-form-item label="选择渠道:">
              <el-select
                v-model="channelId"
                filterable
                clearable
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="item in channelSelectList"
                  :value="item.id"
                  :label="item.name"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <span
              class="msg-style"
              v-if="
                msgKey.game_channel_package_id != undefined ||
                msgKey.game_channel_package_id != null
              "
              >{{ msgError.game_channel_package_id[0] }}</span
            >
          </div>
          <div class="form-part">
            <el-form-item label="预付金额:">
              <el-input placeholder="" v-model="addform.prepaid_amount">
              </el-input>
            </el-form-item>
            <span
              class="msg-style"
              v-if="
                msgKey.prepaid_amount != undefined ||
                msgKey.prepaid_amount != null
              "
              >{{ msgError.prepaid_amount[0] }}</span
            >
          </div>
          <div class="form-part">
            <el-form-item label="预警阈值:">
              <el-select
                v-model="percentageId"
                filterable
                clearable
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="item in percentage"
                  :value="item.id"
                  :label="item.rate + '%'"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <span
              class="msg-style"
              v-if="
                msgKey.valve_percentage != undefined ||
                msgKey.valve_percentage != null
              "
              >{{ msgError.valve_percentage[0] }}</span
            >
          </div>
          <div class="form-part">
            <el-form-item label="通知手机:">
              <el-input placeholder="" v-model="addform.phone_number">
              </el-input>
            </el-form-item>
            <span
              class="msg-style"
              v-if="
                msgKey.phone_number != undefined || msgKey.phone_number != null
              "
              >{{ msgError.phone_number[0] }}</span
            >
          </div>
          <div class="form-part">
            <el-form-item label="通知邮箱:">
              <el-input placeholder="" v-model="addform.email"> </el-input>
            </el-form-item>
            <span
              class="msg-style"
              v-if="msgKey.email != undefined || msgKey.email != null"
              >{{ msgError.email[0] }}</span
            >
          </div>
          <div class="form-part">
            <el-form-item label="结算类型:">
              <el-select
                v-model="addform.method"
                filterable
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in methodList"
                  :value="item.key"
                  :label="item.name"
                  :key="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <span
              class="msg-style"
              v-if="msgKey.method != undefined || msgKey.method != null"
              >{{ msgError.method[0] }}</span
            >
          </div>
          <div class="form-part">
            <el-form-item label="">
              <div class="form-part">
                <el-table
                  stripe
                  style="width: 100%; margin-bottom: 30px"
                  :data="dialogBindData.tbAssessItems"
                >
                  <el-table-column label="流水" prop="keep_amount">
                    <template slot-scope="scope">
                      <div
                        style="display: flex; align-items: center"
                        v-if="scope.row.show"
                      >
                        <el-input
                          v-model="scope.row.keep_amount"
                          placeholder=""
                        ></el-input>
                      </div>
                      <span v-else>{{ scope.row.keep_amount }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="分成比例" prop="divide">
                    <template slot-scope="scope">
                      <div
                        style="display: flex; align-items: center"
                        v-if="scope.row.show"
                      >
                        <el-input
                          v-model="scope.row.divide"
                          placeholder=""
                        ></el-input
                        >%
                      </div>
                      <span v-else>{{ scope.row.divide }}%</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        icon="el-icon-edit"
                        circle
                        v-if="!scope.row.show"
                        @click="editRow(scope.$index, scope.row)"
                      ></el-button>
                      <el-button
                        type="success"
                        icon="el-icon-check"
                        circle
                        v-if="scope.row.show"
                        @click="complete(scope.$index, scope.row)"
                      ></el-button>
                      <el-button
                        type="danger"
                        icon="el-icon-delete"
                        circle
                        @click.native.prevent="
                          deleteRow(scope.$index, dialogBindData.tbAssessItems)
                        "
                      ></el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="addGear">
                  <span @click="addGear"
                    ><i class="el-icon-circle-plus"></i>添加新档位</span
                  >
                </div>
              </div>
            </el-form-item>
            <span
              class="msg-style"
              style="top: auto; bottom: 0"
              v-if="msgKey.grades != undefined || msgKey.grades != null"
              >{{ msgError.grades[0] }}</span
            >
          </div>

          <div class="dialog-footer dialog-footerRE">
            <el-button type="primary" @click="proAddConfirm">提交</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>

    <!-- 预付池 编辑弹窗 -->
    <el-dialog
      title="编辑项目"
      :visible.sync="editDialogFormVisible"
      :close-on-click-modal="false"
      style="margin-top: 5vh"
      width="38%"
    >
      <div>
        <el-form ref="form" :model="editform" label-width="90px">
          <div class="form-part">
            <el-form-item label="项目名称:">
              <el-input placeholder="" v-model="editform.project_name" disabled>
              </el-input>
            </el-form-item>
            <span
              class="msg-style"
              v-if="
                msgKey.project_name != undefined || msgKey.project_name != null
              "
              >{{ msgError.project_name[0] }}</span
            >
          </div>
          <div class="form-part">
            <el-form-item label="选择渠道:">
              <el-select
                v-model="channelEditId"
                filterable
                clearable
                multiple
                disabled
                placeholder="请选择"
              >
                <el-option
                  v-for="item in channelSelectList"
                  :value="item.id"
                  :label="item.name"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <span
              class="msg-style"
              v-if="
                msgKey.game_channel_package_id != undefined ||
                msgKey.game_channel_package_id != null
              "
              >{{ msgError.game_channel_package_id[0] }}</span
            >
          </div>
          <div class="form-part">
            <el-form-item label="预付金额:">
              <el-input
                placeholder=""
                v-model="editform.prepaid_amount"
                disabled
              >
              </el-input>
            </el-form-item>
            <span
              class="msg-style"
              v-if="
                msgKey.prepaid_amount != undefined ||
                msgKey.prepaid_amount != null
              "
              >{{ msgError.prepaid_amount[0] }}</span
            >
          </div>
          <div class="form-part">
            <el-form-item label="预警阈值:">
              <el-select
                v-model="percentageEditId"
                filterable
                clearable
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="item in percentage"
                  :value="item.id"
                  :label="item.rate + '%'"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <span
              class="msg-style"
              v-if="
                msgKey.valve_percentage != undefined ||
                msgKey.valve_percentage != null
              "
              >{{ msgError.valve_percentage[0] }}</span
            >
          </div>
          <div class="form-part">
            <el-form-item label="通知手机:">
              <el-input placeholder="" v-model="editform.phone_number">
              </el-input>
            </el-form-item>
            <span
              class="msg-style"
              v-if="
                msgKey.phone_number != undefined || msgKey.phone_number != null
              "
              >{{ msgError.phone_number[0] }}</span
            >
          </div>
          <div class="form-part">
            <el-form-item label="通知邮箱:">
              <el-input placeholder="" v-model="editform.email"> </el-input>
            </el-form-item>
            <span
              class="msg-style"
              v-if="msgKey.email != undefined || msgKey.email != null"
              >{{ msgError.email[0] }}</span
            >
          </div>
          <div class="form-part">
            <el-form-item label="结算类型:">
              <el-select
                v-model="editform.method"
                filterable
                clearable
                disabled
                placeholder="请选择"
              >
                <el-option
                  v-for="item in methodList"
                  :value="item.key"
                  :label="item.name"
                  :key="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <span
              class="msg-style"
              v-if="msgKey.method != undefined || msgKey.method != null"
              >{{ msgError.method[0] }}</span
            >
          </div>
          <div class="form-part">
            <el-form-item label="">
              <div class="form-part">
                <el-table
                  stripe
                  style="width: 100%; margin-bottom: 30px"
                  :data="dialogBindData.tbAssessItems"
                >
                  <el-table-column label="流水" prop="keep_amount">
                    <template slot-scope="scope">
                      <div
                        style="display: flex; align-items: center"
                        v-if="scope.row.show"
                      >
                        <el-input
                          v-model="scope.row.keep_amount"
                          placeholder=""
                        ></el-input>
                      </div>
                      <span v-else>{{ scope.row.keep_amount }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="分成比例" prop="divide">
                    <template slot-scope="scope">
                      <div
                        style="display: flex; align-items: center"
                        v-if="scope.row.show"
                      >
                        <el-input
                          v-model="scope.row.divide"
                          placeholder=""
                        ></el-input
                        >%
                      </div>
                      <span v-else>{{ scope.row.divide }}%</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        icon="el-icon-edit"
                        circle
                        v-if="!scope.row.show"
                        @click="editRow(scope.$index, scope.row)"
                      ></el-button>
                      <el-button
                        type="success"
                        icon="el-icon-check"
                        circle
                        v-if="scope.row.show"
                        @click="complete(scope.$index, scope.row)"
                      ></el-button>
                      <el-button
                        type="danger"
                        icon="el-icon-delete"
                        circle
                        @click.native.prevent="
                          deleteRow(scope.$index, dialogBindData.tbAssessItems)
                        "
                      ></el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="addGear">
                  <span @click="addGear"
                    ><i class="el-icon-circle-plus"></i>添加新档位</span
                  >
                </div>
              </div>
            </el-form-item>
            <span
              class="msg-style"
              style="top: auto; bottom: 0"
              v-if="msgKey.grades != undefined || msgKey.grades != null"
              >{{ msgError.grades[0] }}</span
            >
          </div>

          <div class="dialog-footer dialog-footerRE">
            <el-button type="primary" @click="proEditConfirm">提交</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>

    <!-- 预付池 详情弹窗 -->
    <el-dialog
      title="查看详情"
      :visible.sync="detailsFormVisible"
      :close-on-click-modal="false"
      style="margin-top: 5vh"
      width="38%"
    >
      <div v-show="isShowPro">
        <el-form ref="form" :model="poolDetailList" label-width="90px">
          <el-form-item label="项目名称:">
            <el-input
              placeholder=""
              v-model="poolDetailList.project_name"
              :disabled="true"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="选择渠道:">
            <el-select
              v-model="channel_id"
              filterable
              clearable
              disabled
              multiple
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in channelSelectList"
                :value="item.id"
                :label="item.name"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="预付金额:">
            <el-input
              placeholder=""
              v-model="poolDetailList.surplus_prepaid_amount"
              :disabled="true"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="预警阈值:">
            <el-select
              v-model="rate"
              filterable
              clearable
              multiple
              disabled
              placeholder="请选择"
            >
              <el-option
                v-for="item in percentage"
                :value="item.id"
                :label="item.rate + '%'"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="通知手机:">
            <el-input
              placeholder=""
              v-model="poolDetailList.phone_number"
              :disabled="true"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="通知邮箱:">
            <el-input
              placeholder=""
              v-model="poolDetailList.email"
              :disabled="true"
            >
            </el-input>
          </el-form-item>

          <div class="dialog-footer dialog-footerRE">
            <el-button type="primary" plain @click="next">下一步</el-button>
          </div>
        </el-form>
      </div>
      <div v-show="isShowGrade">
        <el-form ref="form" :model="poolDetailList" label-width="90px">
          <el-form-item label="结算类型:">
            <el-select
              v-model="settlement"
              filterable
              clearable
              disabled
              placeholder="请选择"
            >
              <el-option
                v-for="item in methodList"
                :value="item.key"
                :label="item.name"
                :key="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-table stripe :data="gradeInfo">
              <el-table-column label="流水" prop="keep_amount">
                <template slot-scope="scope">
                  <span>{{ scope.row.keep_amount }}</span>
                </template>
              </el-table-column>
              <el-table-column label="分成比例" prop="divide">
                <template slot-scope="scope">
                  <span>{{ scope.row.divide }}%</span>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <!-- 预付池 添加库存 -->
    <el-dialog
      title="添加库存"
      :visible.sync="addPoolDialogFormVisible"
      :close-on-click-modal="false"
      style="margin-top: 5vh"
      width="26%"
    >
      <el-form ref="form" label-width="90px">
        <el-form-item label="充值金额:">
          <el-input placeholder="充值预付池金额" v-model="amount"> </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="addPoolDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="poolAdd()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
export default {
  name: "prepaidPool",
  data() {
    return {
      loadingData: false,
      detailsFormVisible: false,
      addDialogFormVisible: false,
      editDialogFormVisible: false,
      addPoolDialogFormVisible: false,
      isShowPro: true,
      isShowGrade: false,
      isShowProAdd: true,
      isShowGradeAdd: false,
      tableData: [],
      tableHeight: 0,
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      tabNum: 0,
      searchValue: {
        keyword: "",
      },
      addform: {
        project_name: "",
        game_channel_package_id: [],
        prepaid_amount: "",
        email: "",
        phone_number: "",
        valve_percentage: [],
        method: "",
        grades: [],
      },
      editform: {
        project_id: "",
        project_name: "",
        game_channel_package_id: [],
        prepaid_amount: "",
        email: "",
        phone_number: "",
        valve_percentage: [],
        method: "",
        grades: [],
      },
      historyValue: {},
      poolList: [
        {
          id: "all",
          name: "全部项目",
        },
        {
          id: "cooperate",
          name: "合作中",
        },
        {
          id: "normal",
          name: "正常",
        },
        {
          id: "soon",
          name: "快没钱",
        },
        {
          id: "close",
          name: "不合作",
        },
      ],
      percentage: [
        {
          id: 0,
          rate: "0",
        },
        {
          id: 5,
          rate: "5",
        },
        {
          id: 10,
          rate: "10",
        },
        {
          id: 15,
          rate: "15",
        },
        {
          id: 20,
          rate: "20",
        },
        {
          id: 25,
          rate: "25",
        },
        {
          id: 30,
          rate: "30",
        },
        {
          id: 35,
          rate: "35",
        },
        {
          id: 40,
          rate: "40",
        },
        {
          id: 45,
          rate: "45",
        },
        {
          id: 50,
          rate: "50",
        },
      ],
      poolDetailList: {},
      channelSelectList: [],
      channel_id: [],
      rate: [],
      settlement: "",
      gradeInfo: [],
      methodList: [],
      dialogBindData: {
        tbAssessItems: [],
      },
      tablelist: {
        rowNum: 1,
        keep_amount: "",
        divide: "",
      },
      packageList: {
        id: "",
        name: "",
      },
      percentageList: {
        rate: "",
        read: 0,
      },
      packageListEdit: {
        id: "",
        name: "",
      },
      percentageListEdit: {
        rate: "",
        read: 0,
      },
      channelId: [],
      channelEditId: [],
      percentageId: [],
      percentageEditId: [],
      msgKey: {},
      msgError: {
        project_name: "",
        game_channel_package_id: "",
        prepaid_amount: "",
        email: "",
        phone_number: "",
        valve_percentage: "",
        method: "",
        grades: "",
      },
      poolProList: {},
      amount: "",
      project_id: "",
      total: "all",
    };
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    this.getchannelSelectList();
    this.getMethodList();
    this.getPoolProList();
    this.getPoolList(this.total, 0, true);
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getPoolList(this.total, 0, false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPoolList(this.total, 0, false);
    },
    // 获取渠道选择列表数据
    getchannelSelectList() {
      fetch({
        url: "/admin/prepaid_pool/getGameChannelPackage",
        method: "GET",
      }).then((res) => {
        this.channelSelectList = res.data.data;
      });
    },
    // 获取结算类型数据
    getMethodList() {
      fetch({
        url: "/admin/prepaid_pool/getMethodList",
        method: "GET",
      }).then((res) => {
        this.methodList = res.data.data;
      });
    },
    // 实现预付池列表搜索
    searchPoolList() {
      this.currentPage = 1;
      this.getPoolList(this.total, 0, true);
    },
    // 展示预付池列表数据
    getPoolList(total, i, reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      this.tabNum = i;
      fetch({
        url: "/admin/prepaid_pool/listProject",
        method: "GET",
        params: {
          ...searchValue, // 传对应的搜索的值
          total: total,
          page: this.currentPage,
          limit: this.pageSize,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data.data;
            this.totalRecords = res.data.data.total;
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },

    // 预付池详情弹窗
    poolDetails(row, id) {
      this.poolDetailList = row;
      this.gradeInfo = [];
      this.channel_id = [];
      this.rate = [];
      let that = this;
      row.game_channel_package_id.forEach((channel, i) => {
        that.channel_id.push(channel.id);
      });
      row.valve_percentage.forEach((val, i) => {
        that.rate.push(val.rate);
      });
      row.grade.forEach((data, i) => {
        that.gradeInfo.push(data);
      });
      that.settlement = row.method.name;
      this.detailsFormVisible = true;
      this.isShowPro = true;
      this.isShowGrade = false;
    },
    // 详情点击下一步
    next() {
      this.isShowPro = false;
      this.isShowGrade = true;
    },
    // 新增点击下一步
    // nextAdd() {
    //   if (
    //     this.addform.project_name == "" ||
    //     this.addform.game_channel_package_id == [] ||
    //     this.addform.email == "" ||
    //     this.addform.phone_number == "" ||
    //     this.addform.valve_percentage == [] ||
    //     this.addform.prepaid_amount == "" ||
    //     this.addform.grades == []
    //   ) {
    //     this.$message.error("所有输入框/选项均必填");
    //   } else {
    //     this.isShowProAdd = false;
    //     this.isShowGradeAdd = true;
    //   }
    // },

    // 新增项目 点击事件
    addPro() {
      this.addform = {
        project_name: "",
        game_channel_package_id: [],
        prepaid_amount: "",
        email: "",
        phone_number: "",
        valve_percentage: [],
        method: "",
        grades: [],
      };
      this.packageList = {
        id: "",
        name: "",
      };
      this.percentageList = {
        rate: "",
        read: 0,
      };
      this.dialogBindData = {
        tbAssessItems: [],
      };
      this.channelId = [];
      this.percentageId = [];
      this.msgKey = {};
      this.addDialogFormVisible = true;
    },

    // 项目新增 提交方法
    proAddConfirm() {
      this.addform.game_channel_package_id = [];
      this.addform.valve_percentage = [];
      let that = this;
      this.channelId.forEach((item) => {
        that.channelSelectList.forEach((data) => {
          if (item == data.id) {
            that.packageList = {
              id: data.id,
              name: data.name,
            };
            that.addform.game_channel_package_id.push(that.packageList);
          }
        });
      });
      this.percentageId.forEach((item) => {
        that.percentage.forEach((data) => {
          if (item == data.id) {
            that.percentageList = {
              rate: data.rate,
              read: 0,
            };
            that.addform.valve_percentage.push(that.percentageList);
          }
        });
      });
      fetch({
        url: "/admin/prepaid_pool/createProject",
        method: "POST",
        data: {
          ...this.addform,
          grades: this.dialogBindData.tbAssessItems,
          game_channel_package_id: this.addform.game_channel_package_id,
          valve_percentage: this.addform.valve_percentage,
        },
      }).then((res) => {
        if (res.data.status === 1) {
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.getPoolList();
          this.addDialogFormVisible = false;
        } else {
          this.msgKey = res.data.message;
          let msg = res.data.message;
          let that = this;
          if (typeof msg == "object") {
            Object.keys(msg).forEach(function (key) {
              that.msgError[key] = msg[key];
            });
          } else {
            this.$message.error(res.data.message);
          }
        }
      });
    },

    // 项目编辑
    poolEditDialog(row) {
      this.channelEditId = [];
      this.editform.game_channel_package_id = [];
      this.editform.valve_percentage = [];
      this.percentageEditId = [];
      let that = this;
      this.editform.project_id = row.project_id;
      this.editform.project_name = row.project_name;

      this.editform.prepaid_amount = row.surplus_prepaid_amount;
      this.editform.email = row.email;
      this.editform.phone_number = row.phone_number;

      row.game_channel_package_id.forEach((item) => {
        that.packageListEdit = {
          id: item.id,
          name: item.name,
        };
        that.channelEditId.push(item.id);
        that.editform.game_channel_package_id.push(that.packageListEdit);
      });
      row.valve_percentage.forEach((item) => {
        that.percentageListEdit = {
          rate: item.rate,
          read: 0,
        };
        that.percentageEditId.push(item.rate);
        that.editform.valve_percentage.push(that.percentageListEdit);
      });
      this.editform.method = row.method.name;
      this.dialogBindData.tbAssessItems = row.grade;

      this.editDialogFormVisible = true;
    },

    // 项目编辑 提交方法
    proEditConfirm() {
      this.editform.valve_percentage = [];
      let that = this;
      this.percentageEditId.forEach((item) => {
        that.percentage.forEach((data) => {
          if (item == data.id) {
            that.percentageListEdit = {
              rate: data.rate,
              read: 0,
            };
            that.editform.valve_percentage.push(that.percentageListEdit);
          }
        });
      });
      fetch({
        url: "/admin/prepaid_pool/editProject",
        method: "POST",
        data: {
          ...this.editform,
          grades: this.dialogBindData.tbAssessItems,
          game_channel_package_id: this.editform.game_channel_package_id,
          valve_percentage: this.editform.valve_percentage,
        },
      }).then((res) => {
        if (res.data.status === 1) {
          this.$message({
            type: "success",
            message: "编辑成功",
          });
          this.getPoolList();
          this.editDialogFormVisible = false;
        } else {
          this.msgKey = res.data.message;
          let msg = res.data.message;
          let that = this;
          if (typeof msg == "object") {
            Object.keys(msg).forEach(function (key) {
              that.msgError[key] = msg[key];
            });
          } else {
            this.$message.error(res.data.message);
          }
        }
      });
    },

    // 单行 添加
    addGear() {
      this.tablelist = {
        rowNum: this.dialogBindData.tbAssessItems.length + 1,
        keep_amount: "",
        divide: "",
      };
      this.dialogBindData.tbAssessItems.push(this.tablelist);
    },
    // 单行 编辑
    editRow(index, row) {
      // 备份原始数据
      row["oldRow"] = JSON.parse(JSON.stringify(row));
      this.$set(this.dialogBindData.tbAssessItems[index], "show", true);
    },
    // 单行 完成
    complete(index, row) {
      this.dialogBindData.tbAssessItems[index].show = false;
    },

    // 单行 删除
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },

    // 项目数
    getPoolProList() {
      fetch({
        url: "/admin/prepaid_pool/totalProject",
        method: "GET",
      }).then((res) => {
        this.poolProList = res.data.data;
      });
    },

    // 添加库存
    poolAddDialog(project_id) {
      this.project_id = project_id;
      this.amount = "";
      this.addPoolDialogFormVisible = true;
    },
    // 添加库存提交
    poolAdd() {
      fetch({
        url: "/admin/prepaid_pool/recharge",
        method: "POST",
        data: {
          project_id: this.project_id,
          amount: parseFloat(this.amount),
        },
      }).then((res) => {
        if (res.data.status === 1) {
          this.$message.success(res.data.data);
          this.getPoolList();
          this.addPoolDialogFormVisible = false;
        } else {
          this.$message.error(res.data.message.amount[0]);
        }
      });
    },
    // 下架
    closeProejct(project_id) {
      this.$confirm("是否确定取消合作?", "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.closeProejctSubmit(project_id);
        })
        .catch(() => {});
    },
    // 下架通知
    closeProejctSubmit(project_id) {
      fetch({
        url: "/admin/prepaid_pool/closeProejct",
        method: "POST",
        data: {
          project_id: project_id,
        },
      }).then((res) => {
        if (res.data.status === 1) {
          this.$message.success(res.data.data);
          this.getPoolList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
  },
};
</script>
<style lang="less">
.pool_hd {
  padding: 40px 0;
  border: 1px solid #e9e9e9;
  box-shadow: 0 0 5px #e9e9e9;
  border-radius: 12px;
  ul {
    display: flex;
  }
  li {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: rgba(0, 0, 0, 0.6);
  }
  span {
    color: rgba(0, 0, 0, 0.3);
    font-size: 14px;
  }
  em {
    font-style: normal;
    font-size: 42px;
    font-weight: 600;
  }
}
.pool_bd {
  border: 1px solid #e9e9e9;
  box-shadow: 0 0 5px #e9e9e9;
  border-radius: 12px;
  margin-top: 30px;
  padding: 40px;
}
.pool_bd_title {
  display: flex;

  justify-content: space-between;
  .el-input-group {
    width: 320px;
    margin-left: 30px;
  }
}
.pool_bd_content {
  display: flex;
  margin-bottom: 20px;
}
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}
.pool_tab {
  border: 1px solid rgba(0, 0, 0, 0.1);
  // border-radius: 8px;
  height: 40px;
  line-height: 40px;
  display: flex;
  color: rgba(0, 0, 0, 0.5);
  div {
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    &:last-child {
      border-right: none;
    }
  }
}
.addGear {
  text-align: center;
  span {
    cursor: pointer;
  }
  i {
    color: #409eff;
    margin-right: 3px;
  }
}
.dialog-footerRE {
  text-align: center;
  padding-top: 10px;
  .el-button {
    width: 50%;
  }
}
.form-part {
  position: relative;
  .el-select {
    width: 100%;
  }
}
.msg-style {
  color: #eb3941;
  font-size: 12px;
  position: absolute;
  left: 93px;
  top: 42px;
}
.pool_tab_box > div.active {
  background: #409eff;
  color: #ffffff;
}
.pool_tab_box {
  span {
    display: inline-block;
    padding: 0 20px;
    cursor: pointer;
  }
}
</style>